import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import  { createLogger } from 'redux-logger';
import recordsReducer from '../reducers/recordsReducer';
import authReducer from '../reducers/authReducer';
import noticeReducer from '../reducers/noticeReducer';
import noticeMiddleware from '../middlewares/noticeMiddleware';
import mailMiddleware from '../middlewares/mailMiddleware';

let logger = process.env.NODE_ENV === "production" ? null : createLogger();

let middlewares = ([
  thunk,
  logger,
  noticeMiddleware,
  mailMiddleware
]).filter(Boolean);

const store = createStore(
  combineReducers({
    records: recordsReducer,
    auth: authReducer,
    notice: noticeReducer
  }),
  applyMiddleware(...middlewares)
);

export default store;


// WEBPACK FOOTER //
// ./src/stores/store.js